<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="1700px"
    title="AI审单"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    append-to-body
    top="5vh"
    draggable
  >
    <div v-loading="loading" class="content">
      <div class="form">
        <el-form ref="formRef" :model="form" label-width="auto" :rules="rules" label-position="top">
          <el-form-item label="总税金" prop="taxAmount">
            <number-range v-model="form.taxAmount" style="width: 100%" :min="0.01" :precision="2" :max="990000"> </number-range>
          </el-form-item>
          <el-form-item label="总价值" prop="totalAmount">
            <number-range v-model="form.totalAmount" style="width: 100%" :min="0.01" :precision="2" :max="990000"> </number-range>
          </el-form-item>
          <el-form-item label="总条目" prop="calcCount">
            <el-input-number v-model="form.calcCount" style="width: 100%" controls-position="right" :min="1" :precision="0" :step="1">
            </el-input-number>
          </el-form-item>
        </el-form>
        <div class="btn" @click="createTask('formRef')">{{ rowData.invoiceTaskId ? '重新生成' : '生成发票' }}</div>
      </div>
      <div class="data">
        <BaseTable :tableData="tableData" height="787" :isPager="false">
          <template slot="productName" slot-scope="row">
            <p>
              <span class="label">唛头</span>
              <span class="value">{{ row.scope.mark }}</span>
            </p>
            <p>
              <span class="label">Product name</span>
              <span class="value">{{ row.scope.nameEN }}</span>
            </p>
            <p>
              <span class="label">中文品名</span>
              <span class="value">{{ row.scope.nameCH }}</span>
            </p>
          </template>
          <template slot="usedFor" slot-scope="row">
            <p>
              <span class="label">Material</span>
              <span class="value">{{ row.scope.material }}</span>
            </p>
            <p>
              <span class="label">Used for</span>
              <span class="value">{{ row.scope.usedFor }}</span>
            </p>
          </template>
          <template slot="qty" slot-scope="row">
            <div style="display: flex">
              <p style="width: 50%">
                <span class="label">箱数</span>
                <span class="value">{{ row.scope.packages }}</span>
              </p>
              <p style="width: 50%">
                <span class="label">产品净重</span>
                <span class="value">{{ row.scope.netWeight }}</span>
              </p>
            </div>
            <div style="display: flex">
              <p style="width: 50%">
                <span class="label">产品个数</span>
                <span class="value">{{ row.scope.qty }}</span>
              </p>
              <p style="width: 50%">
                <span class="label">产品毛重</span>
                <span class="value">{{ row.scope.grossWeight }}</span>
              </p>
            </div>
            <div>
              <p style="width: 50%">
                <span class="label">产品单价</span>
                <span class="value">{{ row.scope.unitPrice }}</span>
              </p>
            </div>
          </template>
          <template slot="ston" slot-scope="row">
            <div style="display: flex">
              <p style="width: 50%">
                <span class="label">铜净重</span>
                <span class="value">{{ row.scope.copperNetWeight }}</span>
              </p>
              <p style="width: 50%">
                <span class="label">钢铝净重</span>
                <span class="value">{{ row.scope.steelAluminiumNetWeight }}</span>
              </p>
            </div>
          </template>
          <template slot="hsCode" slot-scope="row">
            <span style="font-weight: bold">{{ row.scope.hsCode }}</span>

            <!-- E:\git\customs_clearance\src\assets\images\bill\tax-detail.png -->
          </template>
          <template slot="totalCalculateRate" slot-scope="row">
            {{ row.scope.totalCalculateRate }}
            <el-tooltip class="item" effect="dark" placement="bottom">
              <!-- <div slot="content"><span v-html="htmlContent(row.scope.calculateRateDescription)"></span></div> -->
              <div slot="content">
                <template v-for="item in row.scope.rateList">
                  <div v-if="item.addRate && !item.isAddRateExempt" :key="item.name" class="addRate-item">
                    <span class="title">{{ item.name }}:</span>
                    <span>{{ item.addRate }} %</span>
                    <span v-if="item.isAddRateExempt" class="tip">豁免</span>
                  </div>
                </template>
              </div>
              <img style="margin-top: 5px" src="@/assets/images/bill/tax-detail.png" />
            </el-tooltip>
            <!-- calculateRateDescription -->
          </template>
          <template slot="totalAmount" slot-scope="row">
            <span style="font-weight: bold">{{ row.scope.totalAmount }}</span>
          </template>
        </BaseTable>
      </div>
    </div>
    <template slot="footer">
      <div class="footer flex_c_c">
        <div class="cancel flex_c_c" @click="cancel">取消</div>
        <div class="ok flex_c_c" @click="ok">确认录入</div>
      </div>
    </template>
    <ReCreatedInvoiceDialog :dialogVisible="dialogVisible2" @cancel="dialogVisible2 = false" @ok="reCreated"></ReCreatedInvoiceDialog>
  </el-dialog>
</template>

<script>
import BaseTable from '@/components/table/BaseTable.vue'
import NumberRange from '../base/NumberRange.vue'
import ReCreatedInvoiceDialog from './ReCreatedInvoiceDialog'
import { aiGenerateInvoice, getInvoiceProductDetails } from '@/api/bill'
export default {
  components: { BaseTable, NumberRange, ReCreatedInvoiceDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    productList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'productName',
            label: '产品信息',
            width: '300px',
            isCustom: true
          },
          {
            filed: 'usedFor',
            label: '材质用途',
            width: '300px',
            isCustom: true
          },
          {
            filed: 'qty',
            label: '数据信息',
            width: '300px',
            isCustom: true
          },
          {
            filed: 'ston',
            label: '钢铁铝占比',
            width: '300px',
            isCustom: true
          },
          {
            filed: 'hsCode',
            label: 'US海关编码',
            width: '160px',
            isCustom: true
          },
          {
            filed: 'totalCalculateRate',
            label: '总税率',
            width: '200px',
            isCustom: true
          },
          {
            filed: 'totalAmount',
            label: '总税额',
            width: '200px',
            isCustom: true
          }
        ],
        columns: []
      },
      loading: false,
      form: {
        taxAmount: [0, 99999],
        totalAmount: [0, 99999],
        calcCount: 0
      },
      rules: {
        taxAmount: [{ required: true, message: '请选择总税金', trigger: 'blur' }],
        totalAmount: [{ required: true, message: '请选择总价值', trigger: 'blur' }],
        calcCount: [{ required: true, message: '请选择总条目', trigger: 'blur' }]
      },
      timer: null,
      dialogVisible2: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.form.taxAmount = [this.rowData.minTax, this.rowData.maxTax]
        const obj = {
          0: '任务进行中',
          1: '已成功',
          2: '已失败'
        }
        if (obj[this.rowData.invoiceTaskStatus]) {
          this.rowData.invoiceTaskStatus === 0 && this.getDetailTimer()
          this.rowData.invoiceTaskStatus === 1 && this.getDetailTimer()
          this.rowData.invoiceTaskStatus === 2 && this.$message.error('生成失败')
        }
      }
    }
  },
  created() {},
  methods: {
    htmlContent(str) {
      return str.split('+').join('<br />')
    },
    cancel() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.$emit('cancel')
    },
    async reCreated(invoiceRetryType) {
      this.dialogVisible2 = false
      try {
        this.loading = true
        const res = await aiGenerateInvoice({
          calcCount: this.form.calcCount,
          minTotalAmount: this.form.totalAmount[0],
          maxTotalAmount: this.form.totalAmount[1],
          minTaxAmount: this.form.taxAmount[0],
          maxTaxAmount: this.form.taxAmount[1],
          mblId: this.rowData.mblId,
          mappingList: this.productList,
          invoiceRetryType
        })
        this.loading = false
        if (res.success) {
          this.$message.success('创建生成任务成功, 请等待...')
          this.getDetailTimer()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    createTask() {
      if (this.productList.length === 0) return
      this.$refs.formRef.validate(async(valid) => {
        if (valid) {
          if (this.rowData.invoiceTaskId) {
            this.dialogVisible2 = true
            return
          }
          this.loading = true
          const res = await aiGenerateInvoice({
            calcCount: this.form.calcCount,
            minTotalAmount: this.form.totalAmount[0],
            maxTotalAmount: this.form.totalAmount[1],
            minTaxAmount: this.form.taxAmount[0],
            maxTaxAmount: this.form.taxAmount[1],
            mblId: this.rowData.mblId,
            mappingList: this.productList
          })
          this.loading = false
          if (res.success) {
            this.$message.success('创建生成任务成功, 请等待...')
            this.getDetailTimer()
          } else {
            this.$message.error(res.errorMessage)
          }
        }
      })
    },
    async getDetailTimer() {
      this.loading = true
      this.timer = setInterval(async() => {
        const res = await getInvoiceProductDetails({
          mblId: this.rowData.mblId
        })
        if (res.success) {
          if (res.data.taskResult === 1 || res.data.taskResult === 2) {
            this.loading = false
            this.$message.success('生成任务成功')
            this.tableData.columns = res.data.list.map((item) => {
              return {
                ...item,
                rateList: [
                  {
                    addRate: item.baseRate,
                    name: '基础加征',
                    isAddRateExempt: false
                  },
                  {
                    addRate: item.addRate,
                    name: '301',
                    isAddRateExempt: item.isAddRateExempt
                  },
                  {
                    addRate: item.addRateTwo,
                    name: '122',
                    isAddRateExempt: item.isAddRateTwoExempt
                  },
                  {
                    addRate: item.addRateThree,
                    name: '钢铝铜加征',
                    isAddRateExempt: item.isAddRateThreeExempt
                  },
                  {
                    addRate: item.addRateFour,
                    name: '半导体',
                    isAddRateExempt: item.isAddRateFourExempt
                  },
                  {
                    addRate: item.addRateFive,
                    name: '汽配税率',
                    isAddRateExempt: item.isAddRateFiveExempt
                  },
                  {
                    addRate: item.addRateSix,
                    name: '铜加征税率',
                    isAddRateExempt: item.isAddRateSixExempt
                  },
                  {
                    addRate: item.addRateSeven,
                    name: '木制品',
                    isAddRateExempt: item.isAddRateSevenExempt
                  },
                  {
                    addRate: item.addRateEight,
                    name: '中、重型卡车',
                    isAddRateExempt: item.isAddRateEightExempt
                  }
                ]
              }
            })
            clearInterval(this.timer)
          }
        } else {
          this.$message.error(res.errorMessage)
          this.loading = false
          clearInterval(this.timer)
        }
      }, 5000)
    },
    ok() {
      if (this.tableData.columns.length === 0) {
        return false
      }
        if (this.timer) {
            clearTimeout(this.timer)
        }
      this.$emit('ok', this.tableData.columns.map(a => {
        return {
            ...a
        }
      }))
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  height: 787px;
  display: flex;
  .form {
    width: 236px;
    height: 100%;
    background: #f7f8fa;
    border-radius: 6px 6px 6px 6px;
    padding: 16px;
    box-sizing: border-box;
    &:deep(.input-number-range) {
      border: 0;
    }
    .btn {
      width: 208px;
      height: 32px;
      background: #5753e8;
      border-radius: 4px 4px 4px 4px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
      margin-top: 100px;
    }
  }
  .data {
    width: calc(100% - 256px);
    margin-left: 20px;
    p {
      width: 100%;
      text-align: left;
    }
    .label {
      width: 94px;
      height: 20px;
      display: inline-block;
      background: #f2f3f5;
      border-radius: 4px 4px 4px 4px;
      text-align: center;
      line-height: 20px;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
    }
    .value {
      margin-left: 8px;
      height: 20px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: #262e47;
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 5px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #cdcdcd;
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    margin-right: 16px;
    cursor: pointer;
  }
}
.footer {
  width: 100%;
  display: flex;
  justify-content: center !important;
  & > div {
    width: 120px;
    height: 40px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;
    text-align: center;
    align-content: center;
    box-sizing: border-box;
    & + div {
      margin-left: 20px;
    }
  }
  .ok {
    color: #ffffff;
    background: #142e79;
  }
  .cancel {
    border: 1px solid #dcdfe6;
  }
}
.addRate-item {
  display: flex;
  align-items: center;
  .title {
    width: 80px;
    margin-right: 5px;
    color: #fff;
    font-weight: bold;
    text-align: right;
  }
  span {
    font-size: 12px;
    color: #fff;
  }
  .tip {
    margin-left: 5px;
    display: block;
    width: 45px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #fff;
    color: #d8251d;
    border-radius: 4px 4px 4px 4px;
  }
}
</style>
